<template>
  <mdb-container class="mt-2">

    <!--    Page main section-->

    <jumbotron :subtitle="$t('seatingType.subtitle')" :title="$t('seatingType.title')"></jumbotron>

    <!--    Buttons-->
    <mdb-row class="justify-content-center mt-3">
      <mdb-col v-for="type in types" :key="type.id" class="mb-3 selection-buttons" col="lg-3">
        <div :class="{'active' :  selectedSeatType.id === type.id}" class="selection-button"
             @click.prevent="updateSeatType(type)">
            <span class="selection-button--icon">
              <img :alt="type.title" :src="type.icon">
            </span>
          <span class="selection-button--text pl-2">
              {{ type.title }}
            </span>
        </div>
      </mdb-col>
    </mdb-row>

    <!--    Next button-->
    <mdb-row class="justify-content-center mt-3">
      <mdb-col>
        <mdb-btn v-if="selectedSeatType.id" block class="large-button btn-primary" @click="next">
          {{ $t('general.next') }}
        </mdb-btn>
      </mdb-col>
    </mdb-row>

  </mdb-container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SeatingType',
  data() {
    return {
      types: []
    }
  },

  metaInfo() {
    return {
      title: this.$t('seatingType.metaTitle')
    }
  },

  mounted() {
    this.$store.dispatch("updateIsLoading", true)

    this.$http.getSeatTypes()
        .then(({data}) => {
          if (data.success) {
            this.types = data.data.options;
            Object.entries(this.types).map(([key, value]) => {
              value.freeTextFieldId = data.data.id;
              value.freeTextFieldType = data.data.title;
            })
          }
        })
        .finally(() => this.$store.dispatch("updateIsLoading", false))
    // this.types = [
    //   {
    //     "id": 1,
    //     "icon": "https://via.placeholder.com/45",
    //     "title": "Reihe"
    //   },
    //   {
    //     "id": 2,
    //     "icon": "https://via.placeholder.com/45",
    //     "title": "Parlament"
    //   },
    //   {
    //     "id": 3,
    //     "icon": "https://via.placeholder.com/45",
    //     "title": "U-Form"
    //   }
    // ];
  },

  computed: {
    ...mapGetters({selectedSeatType: "getSeatType"})
  },

  methods: {
    ...mapActions(["updateSeatType"]),

    next() {
      this.$router.push({name: "ScheduleDuration"})
    }
  }

};
</script>

<style lang="scss" scoped>
@import "_index.scss";
</style>



// WEBPACK FOOTER //
// src/components/pages/seating-type/index.vue